import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { MemberHoursWorkHistoryResults } from "../interface";
import { request } from "@/App/api/request";
import { AuthenticationContext, MemberEligibilityContext } from "@/App/context";

export const getEligibilityMemberHoursWorkHistory = async (authToken: string) => {
  return request<{}, MemberHoursWorkHistoryResults>({
    endpoint: "/eligibility/member_hours/work_history",
    body: {},
  }, authToken);
};

export const useGetEligibilityMemberHoursWorkHistoryQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const { memberEligibility } = useContext(MemberEligibilityContext);

  return useQuery({
    queryFn: async () => {
      return getEligibilityMemberHoursWorkHistory(await getAuthToken());
    },
    queryKey: ["getEligibilityMemberHoursWorkHistory", memberEligibility.plan.id],
  });
};
